import { clientService } from "./client"
import { sessionEndpoints } from "./constant"

// const baseUrl = "https://k8s-prod-avahivei-9d7272afda-676220939.ap-south-1.elb.amazonaws.com/"
// const baseUrl = "http://localhost:8080"
const baseUrl = "https://hivev2.avasoft.com"

export const GetSessions = async (
    empId,
    filter = { startDate: '', endDate: '', status: '' },
    search = '',
    grade = '',
    sort = '',
    limit = 10,
    offset = 0
) => {
    const queryParams = new URLSearchParams({
        ...filter,
        search,
        grade,
        sort,
        limit,
        offset,
    }).toString();
    const url = `${baseUrl}${sessionEndpoints.getSession}/${empId}?${queryParams}`;
    const response = await clientService("GET", url);
    return response;
};

export const PostSessions = async (payload) => {
    const response = await clientService ("POST", baseUrl + sessionEndpoints.postSession, payload);
    return response;
}

export const PostRegistration = async (payload) => {
    const response = await clientService ("POST", baseUrl + sessionEndpoints.postParticipants, payload);
    return response;
}

export const GetParticipants = async (
    sessionId,
    slotId,
    domain = '',
    search = '',
    sort = '',
    limit = 10,
    offset = 0
) => {
    const response = await clientService(
        "GET",
        `${baseUrl}${sessionEndpoints.getParticipants}/${sessionId}/${slotId}?domain=${domain}&search=${search}&sort=${sort}&limit=${limit}&offset=${offset}`
    );
    return response;
};

export const GetDomain = async () => {
    const response = await clientService ("GET", baseUrl + sessionEndpoints.getDomain);
    return response;
}

export const GetEmployeeDetails = async (emailId) => {
    const response = await clientService("GET", `${baseUrl}${sessionEndpoints.getEmployeeDetails}/${emailId}`);
    return response;
}